import { X } from 'lucide-react';


function KPIDetailModal({ title, color, data, columns, onClose }) {
  if (!data) return null;
  const borderColors = {
    red: 'border-red-200', teal: 'border-teal-200', emerald: 'border-emerald-200',
    amber: 'border-amber-200', blue: 'border-blue-200', indigo: 'border-indigo-200',
  };
  const headerColors = {
    red: 'bg-red-50 text-red-700', teal: 'bg-teal-50 text-teal-700', emerald: 'bg-emerald-50 text-emerald-700',
    amber: 'bg-amber-50 text-amber-700', blue: 'bg-blue-50 text-blue-700', indigo: 'bg-indigo-50 text-indigo-700',
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm" onClick={onClose}>
      <div className={`bg-white rounded-xl border-2 ${borderColors[color] || 'border-slate-200'} shadow-2xl w-full max-w-2xl max-h-[80vh] flex flex-col m-4`}
        onClick={e => e.stopPropagation()} data-testid="kpi-detail-modal">
        <div className={`flex items-center justify-between px-5 py-3 rounded-t-xl ${headerColors[color] || 'bg-slate-50 text-slate-700'}`}>
          <h3 className="text-sm font-bold">{title}</h3>
          <button onClick={onClose} className="p-1 hover:bg-white/30 rounded" data-testid="close-kpi-detail">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="overflow-auto flex-1 p-0">
          <table className="w-full text-xs">
            <thead className="sticky top-0 bg-white border-b border-slate-200">
              <tr className="text-[9px] font-bold text-slate-400 uppercase tracking-wider">
                {columns.map(c => (
                  <th key={c.key} className={`px-4 py-2.5 ${c.align === 'right' ? 'text-right' : 'text-left'} font-semibold`}>{c.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row, i) => (
                <tr key={row.code || i} className={`border-t border-slate-100 ${i % 2 === 0 ? '' : 'bg-slate-50/30'} hover:bg-blue-50/20`}>
                  {columns.map(c => (
                    <td key={c.key} className={`px-4 py-2.5 ${c.align === 'right' ? 'text-right' : ''}`}>
                      {c.render ? c.render(row) : (row[c.key] ?? '-')}
                    </td>
                  ))}
                </tr>
              ))}
              {data.length === 0 && (
                <tr><td colSpan={columns.length} className="px-4 py-8 text-center text-slate-400">No data</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default KPIDetailModal;
